import { Suspense } from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import { Loader } from "../Components/Loader";

export const PublicLayout = () => (
  <>
    <Header />
    <main>
      <Suspense fallback={<div>{Loader}</div>}>
        <Outlet />
      </Suspense>
    </main>
    <Footer />
  </>
);